import styled from 'styled-components';
import { isMobile, isTablet, WithBreakpointRange } from '@mews-commander/ui';
import { DecorationImage, Container, Grid, MEDIA_QUERY, Stack, withBreakpointRange } from '@optimus-web/core';
import { getToken, WithChildren } from '@optimus-web/common';
import { capitalMainSectionImage as capitalMainSectionImagePath } from '@mews-commander/assets';

interface MainSectionLayoutProps extends WithBreakpointRange, WithChildren {
    isFullHeight?: boolean;
}

const Image = styled(DecorationImage)`
    background-position: left top;
    ${MEDIA_QUERY.tabletMax} {
        min-height: 210px;
    }
`;

const GridStyled = styled(Grid)<{ isFullHeight?: boolean }>`
    background-color: ${getToken('paletteSemanticOrange25')};
    height: ${({ isFullHeight }) => (isFullHeight ? '100%' : '680px')};
    overflow: hidden;
    ${MEDIA_QUERY.largeDesktopOnly} {
        height: 100%;
    }
`;

const MainSectionLayoutComponent: React.FC<MainSectionLayoutProps> = ({ children, breakpointRange, isFullHeight }) => (
    <GridStyled
        templateColumns="1fr 1fr"
        largePhoneMax={{ templateColumns: '1fr' }}
        gap="0"
        isFullHeight={isFullHeight}
    >
        <Stack vertical spacing="300" alignment="center">
            <Container
                padding={['400', (isMobile(breakpointRange) && '200') || (isTablet(breakpointRange) && '300') || '900']}
            >
                {children}
            </Container>
        </Stack>
        <Image src={capitalMainSectionImagePath} />
    </GridStyled>
);

export const MainSectionLayout = withBreakpointRange(MainSectionLayoutComponent);
